// 话术类型的固定值
export const ROBOT_STATUS = {
  hidenStatus: 1,
  robotStatus: 2,
  textStatus: 3,
  allStatus: 4,
  show: 5,
}

export const ROBOT_TEXT = {
  robot: '电话机器人',
  text: '文字机器人',
  show: '显示',
  hide: '隐藏',
  all: '全部',
  default: '缺省',
}
// 话术类型
export const ROBOT_TYPES = [
  {
    value: ROBOT_STATUS.hidenStatus,
    label: '隐藏',
  },
  {
    value: ROBOT_STATUS.show,
    label: '显示',
  },
]
export const SELECT_OPTIONS = [
  {
    value: 1,
    label: ROBOT_TEXT.all,
  },
  {
    value: ROBOT_STATUS.robotStatus,
    label: ROBOT_TEXT.robot,
  },
  {
    value: ROBOT_STATUS.textStatus,
    label: ROBOT_TEXT.text,
  },
]
// 审核固定值
export const APPLY_STATUS = {
  cross: 2,
  noCross: 3,
  appling: 1,
}
export const APPLY_TEXT = {
  cross: '已审核',
  nocross: '未审核',
}
// 审核选项值
export const APPLY_OPTIONS = [
  {
    label: APPLY_TEXT.nocross,
    value: APPLY_STATUS.appling,
  },
  {
    label: APPLY_TEXT.cross,
    value: APPLY_STATUS.cross,
  },
]

export const SESSION_TYPE = [
  {
    label: '不限',
    value: '',
  },
  {
    label: '正常话术',
    value: 'A',
  },
  {
    label: '兜底话术',
    value: 'B',
  },
  {
    label: '追问话术',
    value: 'Q',
  },
]
export const USER_DEFAULT_AVATAR =
  'https://oss.schoolpi.net/uploads/logo/20201113/f1a5f679d12b03481e78e6c89a4b561c.png'

export const TRIGGER_TYPE = [
  {
    label: '指定意图',
    value: 1,
  },
  {
    label: '挂机',
    value: 2,
  },
]

export const JUMP_POSITION = [
  {
    label: '官网',
    value: 1,
  },
  {
    label: 'SaaS小程序',
    value: 2,
  },
  {
    label: '智能客服',
    value: 3,
  },
]
export const EFFECT_STATUS = [
  {
    label: '未生效',
    value: 1,
  },
  {
    label: '生效',
    value: 2,
  },
]

// 短信模板类型
export const TEMPLATE_TYPE = {
  reply: 3,
  notice: 2,
  replyText: '回复型',
  noticeText: '通知型',
}
